var map = {
	"./images/mohit.gif": 1761
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1760;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team ^.*\/mohit\.gif$
// module id = 1760
// module chunks = 146